var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene-shot-editor ngl-container fill-height"},[_c('NGL',{ref:"nglViewer",attrs:{"shot":_vm.shot,"expanded":_vm.expanded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }